import { isValidNumber, parsePhoneNumber } from 'libphonenumber-js';

export const isValidNum = (numString: string) => {
  return isValidNumber(numString)
}

export const parsePhoneNum = (numString: string) => {
  return parsePhoneNumber(numString)
}
